<header class="emptyHeaderMain"></header>
<div class="container" *ngIf="user">
  <div class="row">
    <div class="col-lg-12 header">
      <h1>Profile</h1>
      <a routerLink="/profile/{{ user._id }}" class="btn btn-secondary">
        How Others See Me
      </a>
    </div>
    <div class="col-lg-4">
      <label class="form-label" for="">Profile Picture</label>
      <app-image-upload
        (uploadStart)="activeUpload = true"
        (uploadComplete)="upload($event)"
        [defaultImage]="
          user.profile_picture || 'image/default_profile_picture.png'
        "></app-image-upload>
    </div>
    <div class="col-lg-8">
      <div class="row">
        <div class="col-lg-6">
          <label class="form-label" for="first_name-field">First Name</label>
          <input
            id="first_name-field"
            [(ngModel)]="user.first_name"
            type="text"
            class="form-control" />
        </div>
        <div class="col-lg-6">
          <label class="form-label" for="name-field">Last Name</label>
          <input
            id="name-field"
            [(ngModel)]="user.name"
            type="text"
            class="form-control" />
        </div>
        <div class="col-lg-6">
          <label class="form-label" for="organization-field">
            Organization
          </label>
          <input
            id="organization-field"
            [(ngModel)]="user.organization"
            type="text"
            class="form-control" />
        </div>
        <div class="col-lg-6">
          <label class="form-label" for="department-field">Department</label>
          <input
            id="department-field"
            [(ngModel)]="user.department"
            type="text"
            class="form-control" />

          <div class="visibility-toggle">
            visible
            <input type="checkbox" [(ngModel)]="user.visibility.department" />
          </div>
        </div>
        <div class="col-lg-6">
          <label class="form-label" for="occupation-field">Occupation</label>
          <input
            id="occupation-field"
            [(ngModel)]="user.occupation"
            type="text"
            class="form-control" />

          <div class="visibility-toggle">
            visible
            <input type="checkbox" [(ngModel)]="user.visibility.occupation" />
          </div>
        </div>
        <div class="col-lg-12">
          <h3>Contact Information</h3>
        </div>
        <div class="col-lg-6">
          <label class="form-label" for="email-field">Email</label>
          <input
            id="email-field"
            [(ngModel)]="user.email"
            type="text"
            class="form-control"
            readonly
            title="If you need to change your email address, either create a new account with your new email address or contact us at info@wedavinci.com" />

          <div class="visibility-toggle">
            visible
            <input type="checkbox" [(ngModel)]="user.visibility.email" />
          </div>
        </div>
        <div class="col-lg-6">
          <label class="form-label" for="zipcode-field">Zip Code</label>
          <input
            id="zipcode-field"
            [(ngModel)]="user.location.zipcode"
            type="text"
            class="form-control" />

          <div class="visibility-toggle">
            visible
            <input
              type="checkbox"
              [(ngModel)]="user.visibility.location.zipcode" />
          </div>
        </div>
        <div class="col-lg-6">
          <label class="form-label" for="city-field">City</label>
          <input
            id="city-field"
            [(ngModel)]="user.location.city"
            type="text"
            class="form-control" />

          <div class="visibility-toggle">
            visible
            <input
              type="checkbox"
              [(ngModel)]="user.visibility.location.city" />
          </div>
        </div>
        <div class="col-lg-6">
          <label class="form-label" for="country-field">Country</label>
          <input
            id="country-field"
            [(ngModel)]="user.location.country"
            type="text"
            class="form-control" />

          <div class="visibility-toggle">
            visible
            <input
              type="checkbox"
              [(ngModel)]="user.visibility.location.country" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 buttons">
      <a routerLink="/change-password" class="btn btn-lg">Change Password</a>
      <button
        class="btn btn-primary btn-lg"
        [disabled]="activeUpload || !changed || !valid"
        (click)="save()">
        {{ saveLabel }}
      </button>
      <br />
      <br />
      <br />
      <br />
    </div>
    <div class="col-lg-4 sect-img">
      <img src="/assets/images/profile-notif-settings.svg" alt />
    </div>
    <div class="col-lg-8">
      <div class="row">
        <div class="col-lg-12">
          <h3>Notification Settings</h3>
          <br />
          <br />
        </div>
        <div class="col-lg-6">
          <label class="form-label" for>
            <input
              type="checkbox"
              [(ngModel)]="
                user.emailSettings.notifEmails.userAddedAsCollaborator
              " />
            You were added as collaborator
          </label>
          <p class="hint">
            To be notified (via email) when you are added as a collaborator on
            an project.
          </p>
          <br />
          <br />
        </div>
        <div class="col-lg-6">
          <label class="form-label" for>
            <input
              type="checkbox"
              [(ngModel)]="
                user.emailSettings.notifEmails.userInvitedAsCollaborator
              " />
            You were invited to collaborate
          </label>
          <p class="hint">
            To be notified (via email) when you are invited to collaborate on an
            project.
          </p>
          <br />
          <br />
        </div>
        <div class="col-lg-6">
          <label class="form-label" for>
            <input
              type="checkbox"
              [(ngModel)]="
                user.emailSettings.notifEmails.someoneAddedAsCollaborator
              " />
            Someone was added as a collaborator
          </label>
          <p class="hint">
            To be notified (via email) when someone has been added as a
            collaborator to an project you either orginiated or collaborator on.
          </p>
          <br />
          <br />
        </div>
        <div class="col-lg-6">
          <label class="form-label" for>
            <input
              type="checkbox"
              [(ngModel)]="
                user.emailSettings.notifEmails.someoneRequestedCollaboration
              " />
            Someone requested to collaborate
          </label>
          <p class="hint">
            To be notified (via email) when someone makes a request to
            collaborate on an project you either originated or collaborated on.
          </p>
          <br />
          <br />
        </div>
        <hr
          style="
            float: left;
            width: 100%;
            border-color: #ddd;
            margin-bottom: 40px;
          " />
        <div class="col-lg-6">
          <label class="form-label" for>
            <input
              type="checkbox"
              [(ngModel)]="user.emailSettings.notifEmails.someoneCommented" />
            Someone made a comment
          </label>
          <p class="hint">
            To be notified (via email) when someone has added comment on an
            project you either originated or collaborated on.
          </p>
          <br />
          <br />
        </div>
        <div class="col-lg-6">
          <label class="form-label" for>
            <input
              type="checkbox"
              [(ngModel)]="user.emailSettings.notifEmails.commentReplied" />
            Somone replied to your comment
          </label>
          <p class="hint">
            To be notified (via email) when someone replied to an earlier
            comment you have made.
          </p>
          <br />
          <br />
        </div>
        <div class="col-lg-6">
          <label class="form-label" for>
            <input
              type="checkbox"
              [(ngModel)]="user.emailSettings.notifEmails.mentionedInComment" />
            Someone mentioned you in a comment
          </label>
          <p class="hint">
            To be notified (via email) when someone has mentioned you in a
            comment.
          </p>
          <br />
          <br />
        </div>
        <hr
          style="
            float: left;
            width: 100%;
            border-color: #ddd;
            margin-bottom: 40px;
          " />
        <div class="col-lg-6">
          <label class="form-label" for>
            <input
              type="checkbox"
              [(ngModel)]="user.emailSettings.notifEmails.directMessage" />
            Direct Message
          </label>
          <p class="hint">
            To be notified (via email) when someone has sent you a direct
            message.
          </p>
          <br />
          <br />
        </div>
      </div>
    </div>
    <div class="col-lg-12 buttons">
      <button
        class="btn btn-primary btn-lg"
        [disabled]="!notifChanged"
        (click)="save()">
        {{ notifChanged ? 'Save' : 'Saved' }}
      </button>
      <br />
      <br />
      <br />
      <br />
    </div>
  </div>
</div>
